import React from 'react'
import { Icon } from '../Icon'
import { StyledExpandArrow } from './ExpandArrow.styles'

export interface ExpandArrowProps {
  $expanded: boolean
  direction?: 'right' | 'down'
  className?: string
  strokeWidth?: number
  size?: 'small' | 'medium' | 'large'
}

export const ExpandArrow: React.FC<ExpandArrowProps> = ({
  $expanded,
  direction = 'right',
  className,
  strokeWidth = 2.5,
  size = 'small',
}) => {
  const iconName = direction === 'right' ? 'chevron-right' : 'chevron-down'
  const rotation = direction === 'right' ? '90deg' : '180deg'

  return (
    <StyledExpandArrow
      $expanded={$expanded}
      $rotation={rotation}
      className={className}
    >
      <Icon name={iconName} size={size} strokeWidth={strokeWidth} />
    </StyledExpandArrow>
  )
}
